import { ENV } from "config/apiConfig";

const isDebugEnabled = ENV === "dev";


export function logDebug(...args) {
  if (isDebugEnabled) {
    console.log(...args);
  }
}

const errorLogs = [];

export function logError(error, context = {}) {
  const logEntry = {
    message: error.message || error.toString(),
    stack: error.stack,
    context,
    timestamp: new Date().toISOString(),
  };
  errorLogs.push(logEntry);
  console.error("Logged error:", logEntry);
  // Optional: Sende den Fehler asynchron an einen Server
}

export function getErrorLogs() {
  return errorLogs;
}

export function clearErrorLogs() {
  errorLogs.length = 0;
}

// Optional: Für globalen Zugriff, hänge sie an window
if (typeof window !== "undefined") {
  window.logger = {
    logDebug,
    logError,
    getErrorLogs,
    clearErrorLogs,
  };
}
